var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":"","flat":""}},[_c('NavBar')],1),_c('v-main',[_c('router-view')],1),_c('v-footer',{staticClass:"mt-8",attrs:{"color":"primary"}},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }